import { Layout } from 'antd';
import { Suspense, useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import SiderCMS from '../SiderCMS/SiderCMS';
import { useDispatch, useSelector } from 'react-redux';
import NotFound from '../../../pages/NotFound/NotFound';
import useModalAuth from '../../auth/AuthModal';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import { clearToken } from '../../../store/reducers/auth.reducer';
import { canAccessCmsPage, canEnterCms } from '../../../utils/permissions';
import ROUTER from '../../../routers/Routers';

const { Content } = Layout;

const CMSLayout = () => {
  const { user, accessToken } = useSelector(state => state.auth);
  const dispatch = useDispatch();
  const { openLogin } = useModalAuth();
  const location = useLocation();
  useDocumentTitle();

  // Super admin vào CMS; tài khoản có quyền khách hàng (customers) chỉ vào trang Khách hàng; các role khác (vd nhà máy
  // MES) có giao diện riêng
  const canAccessCms = canEnterCms(user);

  // Chỉ chuyển sang trang đăng nhập khi chưa đăng nhập. Tài khoản đã đăng nhập mà không có quyền
  // mà cũng chuyển sang /login thì trang đăng nhập (thấy đã có accessToken) đẩy ngược về /cms,
  // gây vòng lặp chuyển trang liên tục.
  useEffect(() => {
    if (canAccessCms) return;
    if (!accessToken) {
      openLogin();
    } else if (!user) {
      // Có token nhưng không đọc được thông tin tài khoản: phiên lỗi, xoá để đăng nhập lại
      dispatch(clearToken());
    }
  }, [canAccessCms, accessToken, user]);

  // Trang không thuộc quyền của tài khoản (vd /cms mặc định chuyển tới Đơn hàng) thì chuyển về trang Khách hàng, là trang
  // duy nhất mọi tài khoản vào được CMS đều mở được
  if (canAccessCms && !canAccessCmsPage(user, location.pathname)) {
    return <Navigate to={ROUTER.CMS + ROUTER.DESIGN_CUSTOMER} replace />;
  }

  if (canAccessCms) {
    return (
      <Layout className="h-screen bg-[#F7F7F7]" hasSider>
        <SiderCMS />
        <Content className="transition-all duration-300 ease-linear">
          <Suspense>
            <Outlet />
          </Suspense>
        </Content>
      </Layout>
    );
  }

  // Đã đăng nhập nhưng không có quyền nào: không vào được CMS
  if (accessToken && user) return <NotFound />;

  return <></>;
};

export default CMSLayout;
